import React from "react";

const NoContent = () => {
  return <div>No Content</div>;
};

export default NoContent;
